import { useEffect, useRef, useState } from 'react';

// Count-up animation. REPLAYS every time it scrolls into view.
// Initial render shows the final value (matches react-snap prerender), then
// animates 0 -> end on each entry. Respects prefers-reduced-motion.
export const CountUp = ({ end, duration = 1400, suffix = '', className = '' }) => {
  const [value, setValue] = useState(end);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (
      typeof IntersectionObserver === 'undefined' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      setValue(end);
      return undefined;
    }

    let raf;
    const animate = () => {
      if (raf) cancelAnimationFrame(raf);
      const start = performance.now();
      setValue(0);
      const tick = (now) => {
        const p = Math.min(Math.max((now - start) / duration, 0), 1);
        const eased = 1 - Math.pow(1 - p, 3);
        setValue(Math.round(eased * end));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) animate();
        });
      },
      { threshold: 0.4 }
    );
    io.observe(node);
    return () => {
      io.disconnect();
      if (raf) cancelAnimationFrame(raf);
    };
  }, [end, duration]);

  return (
    <span ref={ref} suppressHydrationWarning className={className}>
      {value}
      {suffix}
    </span>
  );
};
